<template>

    <v-card class="shopItem">
        <img
            :src="require(`@/assets/images/loja/${this.item.image}`)"
            
            style="width:100%"
        />

        <div >

            <v-card-title primary-title style="margin-bottom: 25%;">
                
                <h3 class="mb-0" style="white-space:nowrap">+ {{ this.item.name }}</h3>
                <br/>
                <div style="font-size: 1em;"> {{ this.item.description }} </div>
                <span class="valor-span"><strong>Valor mensal:</strong> <span style="color:green"> R$ {{ this.item.price }} </span> </span>
                <span class="video-span"><v-icon color="red">mdi-youtube</v-icon><a :href="this.item.link" target="_blank" class="video-link">Vídeo demonstração</a></span>
            </v-card-title>
        
            <div>
                <v-card-actions style="margin-bottom:0px;padding:0px:height:15px;margin-top:22px;position:absolute;bottom:0;width:100%;left:15px;">
                    <v-btn style="color:white;background:teal;width:90%;margin-bottom:10%" :class="[status === 'Em andamento' ? 'analise' : ( status === 'Adquirido' ? 'adquirido' : '' )]" @click="handleClickButton"> <v-icon style="margin-right:3px" small>{{ icon }}</v-icon> {{ status }}</v-btn>
                </v-card-actions>

            

                <v-card-text v-if="status === 'Em andamento'" style="padding:0px;margin-top:-20px;text-align:center;position:absolute;bottom:6px;left:0px;">
                    <span style="color:green;font-size:0.8em;"> Aguarde que nossa equipe entrará em contato. </span>
                </v-card-text>
            </div>
        </div>
    </v-card>
</template>

<script>
import LojaService from '@/domain/loja/LojaService';

export default {
    props: [ "item", "conta", "empresa" ],
    methods: {
        handleClickButton() {
            if(this.item.buttonValue === 'Teste grátis' && this.status !== 'Em andamento'){
                this.status = 'Em andamento';
                let service = new LojaService();
                service.sendEmail(this.conta.id_usuario, this.empresa.cnpj, this.item.id);
            }
        },
    },
    data() {
        return {
            status: this.item.buttonValue,
        }
    },
    computed: {
        icon() {
            if(this.status === 'Em andamento') {
                return 'schedule'
            } else if(this.status === 'Adquirido'){
                return 'done'
            }else {
                return 'mdi-timer-outline'
            }
        },
        // disabled() {
        //     if(this.item.buttonValue === 'Adquirido') {
        //         return true;
        //     }else {
        //         return false;
        //     }
        // }
    },
}
</script>

<style>
    .shopItem {
        margin:2px;
        width: 95%;
        margin-bottom: 9px;
        height: 350px;
    }
    .itemCardImage {
        width: 30%;
    }
    .itemCard {
        padding: 20px;
        margin-right: 15px;
        margin-top: 15px;
        display: flex;
    }
    .itemCardInfo {
        display: flex;
        flex-direction: column;
        width: 70%;
        margin-left: 10px;
    }
    .analise {
        background: #00801c!important;
    }
    .adquirido {
        background: #21219b!important;
    }
    .valor-span {
        font-size: 1em;
        position: absolute;
        bottom: 115px;
    }
    .video-span {
        display:flex;
        align-items:center;
        margin-top:2px;
        position:absolute;
        bottom: 90px;
    }
    .video-link {
        text-decoration:none;
        color:teal;
    }

</style>


// WEBPACK FOOTER //
// src/pages/loggedArea/loja/lojaItem/LojaItem.vue